// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner-module--banner--ayKV9","column":"Banner-module--column--3AYK3"};